import { AppStateType } from 'reducers';
import { isSuperAdmin } from 'utils';
import { createSelector } from 'reselect';
import { jwtDecode } from 'jwt-decode';

export const selectAuthToken = (state: AppStateType) => state.authReducer.user?.auth_token;

export const selectAuthUser = (state: AppStateType) => state.authReducer.user;

export const selectAuth = (state: AppStateType) => state.authReducer;

export const selectAuthAccount = (state: AppStateType) => state.authReducer.user?.account;

export const selectIsSuperAdmin = createSelector(selectAuthUser, (user) => {
  if (!user?.account) return false;

  const { default_team, teams_roles } = user.account;
  const defaultTeamRoles: number[] = teams_roles?.[default_team?.id] || [];

  return isSuperAdmin(defaultTeamRoles);
});

/** Galaxy role names galaxy-server reads from the token's `galaxy_role` claim. */
export const GALAXY_ROLES = {
  SALES: 'salesUser',
  CSM: 'csmUser',
  DEV: 'devUser',
  QA: 'qaUser',
  EXTERNAL: 'externalUser',
} as const;

/**
 * The signed-in user's Galaxy role, read from the auth token galaxy-server
 * authorizes with. Undefined when there is no token or it carries no role.
 * UI hints only: galaxy-server enforces every permission itself.
 */
export const selectGalaxyRole = createSelector(selectAuthToken, (token): string | undefined => {
  if (!token) return undefined;
  try {
    return jwtDecode<{ galaxy_role?: string }>(token).galaxy_role;
  } catch {
    return undefined;
  }
});

/** Error and loading state */
export const selectAuthLoadingState = (state: AppStateType) => state.authReducer.loadingState;

export const selectAuthError = (state: AppStateType) => state.authReducer.error;
